import { SECOND } from './durations';

export { BASE_ROUTES, LANDINGS } from './routes';
export {
  shortMonthsListEn,
  monthsListEn,
  yearsList,
  DEFAULT_MIN_AGE,
  earliestBirthYear,
} from './dates';
export { hoursList, minutesList, partOfDay } from './time';
export { SUGGESTED_DOMAINS } from './emails';
export { ORGANIC_REFERRER_PATTERNS_OBJ } from './attribution';
// ts-prune-ignore-next-line
export { globalClasses, globalZindex } from './classes';
// ts-prune-ignore-next-line
export { DataTestId, DATA_TEST_ID_HTML_ATTRIBUTE } from './data-testid';
export { ROBOTS_CONTENT } from './robots';

export {
  YEAR_IN_DAYS,
  WEEK_IN_DAYS,
  MONTH_IN_DAYS,
  SECOND,
  MINUTE,
  HOUR,
  HOUR_IN_SECONDS,
  TEN_MINUTES_IN_MS,
  YEAR_IN_SECONDS,
  // ts-prune-ignore-next-line
  WEEK_IN_SECONDS,
} from './durations';

export const notAvailable = 'n/a';
export const TESTER_LOADER_DURATION_MULTIPLIER = 1;
export const TESTER_LOADER_DURATION_IN_SEC = TESTER_LOADER_DURATION_MULTIPLIER * SECOND;
